<script>
    // import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import {USER_ROLES} from "../lib/constants";
    import app from "../stores/app";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    // import UserEditModal from "./UserEditModal.svelte";


    let users = null;
    let userId = 0;
    // let editUserId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'agent_id', title: 'AGENCY', sortable: true, class: 'hidden-xs'},
        {key: 'role', title: 'TYPE', sortable: true, class: 'hidden-xs'},
        {key: 'login_at', title: 'LOGIN', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            users = result;
            setListData();
        }

        const onFailure = err => {
        };

        R.handle(R.user.index, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    const setListData = () => {
        users.map(item => {
            if (item.agent_id) {
                let agent = $app.agents.find(x => x.id == item.agent_id);
                if (agent) {
                    item.agent_name = agent.name;
                }
            } else {
                item.agent_name = '';
            }
            item.login_at = formatDate(item.login_at, 'y-m-d');
        });
    }

    const onColumnSort = ({detail}) => {
        users = sort(users, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        // editUserId = 0;
        app.editUser({id: 0}, closeEdit);
    }

    const onEdit = (user) => {
        userId = user.id;
        app.editUser({id: user.id}, closeEdit);
        // editUserId = user.id;
    }

    const closeEdit = (user) => {
        if (user) {
            let properties = ['id', 'agent_id', 'name', 'email', 'role', 'is_active', 'login_at'];

            let item = users.find(x => x.id == user.id);
            if (item) {
                copyObjectProperties(user, item, properties);
                users = users;
            } else {
                users = [copyObjectProperties(user, properties), ...users];
            }
            setListData();
        }
        // editUserId = null;
        app.clearEditUser();
    }

    const onDelete = (user) => {
        Alert.delete("Delete user", `Delete user "${user.name}"?`, () => deleteUser(user.id));
    }

    const deleteUser = id => {
        const onSuccess = result => {
            users = users.filter(x => x.id != result);
            Notifier.showMessage("User deleted");
        }

        const onFailure = err => {
            if (err.code === 'not_allowed') {
                Alert.warning("Delete user", `This is the main administrator.\nYou can not delete this user!`);
                return;
            }

            if (err.code === 'object_related') {
                Alert.warning("Delete user", `This user is related to ${err.params.reservations} reservations.\nYou can not delete this user!`);
            }
        };

        R.handle(R.user.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();

</script>

<PageHeader title="Users" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if users}
    <div class="panel">
        <div class="panel-body">
            {#if users.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each users as item}
                        <tr class="row-hover" class:row-selected="{ userId === item.id }">
                            <td>
                                <button class="btn-reset is-link" class:not-active="{ item.is_active < 1 }"
                                        on:click="{ () => onEdit(item) }">
                                    { item.name }
                                </button>
                                {#if item.agent_name}
                                    <div class="hidden-xl hidden-lg hidden-md hidden-sm text-gray">
                                        {item.agent_name}
                                    </div>
                                {/if}
                                <!--{#if item.email}-->
<!--                                    <div class="hidden-xl hidden-lg hidden-md hidden-sm text-gray">-->
<!--                                        <a href="mailto:{ item.email }">{ item.email }</a>-->
<!--                                    </div>-->
<!--                                {/if}-->
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.email }
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.agent_name }
                            </td>
                            <td class="text-gray date-column hidden-xs">
                                { USER_ROLES[item.role] }
                            </td>
                            <td class="text-gray date-column hidden-xs">
                                { formatDate(item.login_at, 'd-m-y') }
                            </td>
                            <td class="button-column">
                                <button class="button" title="delete" on:click={ () => onDelete(item) }>
                                    <AppIcon icon="trash" size="16"/>
                                </button>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>
{/if}
<!--{#if editUserId != null}-->
<!--    <UserEditModal userId="{ editUserId }" closeCallback="{ closeEdit }"/>-->
<!--{/if}-->